import stateUi from '@state/ui';
import * as React from 'react';
import { Divider, IconRow, InfoColumn, StylelessButton, Title, TopBarBox } from './shared/_styles';
const changeGrid = () => {
    stateUi.showGrid = !stateUi.showGrid;
};
const showExportMenu = () => {
    stateUi.showExportMenu = !stateUi.showExportMenu;
};
const tiltView = () => {
    stateUi.tilted = !stateUi.tilted;
};
const NoneSelectedMutators = () => {
    return (React.createElement(TopBarBox, null,
        stateUi.showAddComponentMenu && 'Click and drag',
        React.createElement(InfoColumn, { style: { marginLeft: 'auto' } },
            React.createElement(Title, null, "Layer view"),
            React.createElement(IconRow, null,
                React.createElement(StylelessButton, { title: "Layers", className: "material-icons", style: {
                        fontSize: '24px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        transform: 'rotateZ(40deg)',
                        color: stateUi.tilted ? ' rgb(83, 212, 134)' : 'black',
                    }, onClick: tiltView }, "layers"))),
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Edit Grid"),
            React.createElement(IconRow, null,
                React.createElement(StylelessButton, { title: "Show grid", className: "material-icons", style: {
                        fontSize: '24px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        color: stateUi.showGrid ? ' rgb(83, 212, 134)' : 'black',
                    }, onClick: changeGrid }, stateUi.showGrid ? 'grid_on' : 'grid_off'))),
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Export"),
            React.createElement(IconRow, null,
                React.createElement(StylelessButton, { title: "Show export menu", className: "material-icons", style: {
                        fontSize: '28px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: '2px',
                        color: stateUi.showExportMenu ? ' rgb(83, 212, 134)' : 'black',
                    }, onClick: showExportMenu }, "exit_to_app")))));
};
export default NoneSelectedMutators;
